import { createStore } from '../.'
import { ICP_LEDGER } from '../../constants/canisterIds'

import type { StateStorage } from 'zustand/middleware'

interface ProtectedCanistersStore {
  protectedCanisterIds: string[]
  setProtectedCanisters: (canisterIds: string[]) => void
}

export const createProtectedCanistersStore = (storage: StateStorage) =>
  createStore<ProtectedCanistersStore>(
    storage,
    (set) => ({
      protectedCanisterIds: [ICP_LEDGER],
      setProtectedCanisters(canisterIds) {
        set({ protectedCanisterIds: canisterIds })
      },
    }),
    {
      persist: {
        name: 'protectedCanisterIds',
        version: 0,
      },
    }
  )
